import { render, staticRenderFns } from "./WithdrawalAddress.vue?vue&type=template&id=5adf719c&"
import script from "./WithdrawalAddress.vue?vue&type=script&lang=js&"
export * from "./WithdrawalAddress.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalAddress.vue?vue&type=style&index=0&id=5adf719c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports